/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import React from 'react';
import { Labeled } from 'react-admin';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import ThumbnailDialogEdit from './ThumbnailDialogEdit';

const styles = (theme) => ({
  button: {
    margin: theme.spacing(),
  },
  extendedIcon: {
    marginRight: theme.spacing(),
  },
});

class UpdateThumbnailButton extends React.Component {
  state = {
    open: false,
  };

  openDialog = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  onValidated = (thumbnail) => {
    this.props.onChange(thumbnail);
    this.handleClose();
  };

  render() {
    return (
      <>
        <Labeled label="Update asset's thumbnail">
          <Button
            size="small"
            variant="contained"
            color="primary"
            onClick={this.openDialog}
          >
            Update Thumbnail
          </Button>
        </Labeled>
        <ThumbnailDialogEdit
          open={this.state.open}
          record={this.props.record[this.props.source]}
          onValidated={this.onValidated}
          close={this.handleClose}
        />
      </>
    );
  }
}

export default withStyles(styles)(UpdateThumbnailButton);
